import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { AuthService } from '@uw/core/services/auth.service';
import { LayoutUtilsService, MessageType } from '@uw/shared/services/layout-utils.service';
import { MenuService } from '@uw/themes/services/menu.service';
import { MyErrorStateMatcher } from '../reset-password/reset-password.component';
import { customEmailValidator } from '@uw/shared/validators/custom-email-validator';
import { MatError } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    imports: [ReactiveFormsModule, MatError, MatButton, RouterLink, TranslateModule]
})
export class ForgotPasswordComponent implements OnInit {


  forgotPasswordFormGrp!: UntypedFormGroup;
  matcher = new MyErrorStateMatcher();
  errorMessage!: string;
  resetToken: string = '';
  email: string = '';
  buttonLoading = false;
  cguid: string = '';

  constructor(private fb: UntypedFormBuilder,
    private authService: AuthService,
    private router: Router,
    private layoutUtilsService: LayoutUtilsService,
    private translateService: TranslateService,
    private activatedRoute: ActivatedRoute,
    private menuService: MenuService,
  ) {
    this.menuService.showDonarSubMenu(true);
    this.createForm();
  }

  ngOnInit(): void {

  }

  createForm() {
    this.forgotPasswordFormGrp = this.fb.group({
      email: [null, [Validators.required, customEmailValidator()]]
    });
  }

  onNoClick(): void {

  }

  sendRequest(): void {
    this.errorMessage = '';
    this.authService.forgotPassword(this.forgotPasswordFormGrp.value.email).subscribe(data => {
      this.showSuccess('forgot_password.success_msg', {email: this.forgotPasswordFormGrp.value.email});
      this.router.navigate(['/login'], { queryParams: { cguid: this.cguid } });

    }, err => {
      console.log(err);
      this.errorMessage = this.translateService.instant('messages.email_not_found');
    });
  }

  showSuccess(message: string, parameters: any) {
    this.layoutUtilsService.showNotification(
      this.translateService.instant(message, parameters),
      MessageType.Success
    );
  }



}
